module.exports = __webpack_public_path__ + "static/media/016_hatena.5c3d6648.gif";